import { FamilleGridKeys } from "../../patients/validators/individualValidators";
import InputIcon from "../../main/components/InputIcon.tsx";
import { FaLongArrowAltDown } from "react-icons/fa";
import {Button} from "@/components/ui/button";
import styles from "./FamilleGridRow.module.css";
import Input from "../../main/components/Input.tsx";
import { formaters } from "vincent-utils";
import { useEffect, useState } from "react";
import { NewPatient, Patients, FamilyRank } from "cadendar-shared";
import { LocalNewPatient } from "./FamilleGridPanel";
import Select4 from "../../../components/Select4";

interface FamilleGridRowProps {
  familyRank: number;
  isValid: { [key in FamilleGridKeys]?: boolean };
  onMembreChange: <K extends FamilleGridKeys>(
    carac: K,
    value: LocalNewPatient[K]
  ) => void;
  onCopyDown: (carac: FamilleGridKeys) => void;
  onRemoveMembre: () => void;
  isSelected: boolean;
  onToggle: () => void;
}

const FamilleGridRow = (
  props: FamilleGridRowProps & {
    [K in FamilleGridKeys]?: (NewPatient | Patients)[K];
  }
) => {
  const { isValid } = props;
  console.log("isValid", isValid);
  const { name, forename, birthdate, portablee164, email, familly_rank } =
    props;
  const { onMembreChange, onCopyDown, onRemoveMembre } = props;

  const portableForDisplay = portablee164
    ? formaters.formatTelNumberForDisplay(portablee164)
    : "";

  const [portableInput, setPortableInput] = useState(portableForDisplay);
  useEffect(() => {
    setPortableInput(portableForDisplay);
  }, [portableForDisplay]);
  const handlePortableChange = (value: string) => {
    setPortableInput(value);
    onMembreChange(
      "portablee164",
      formaters.formatTelNumberForE164(value) || ""
    );
  };
  const handlePortableBlur = () => {
    if (isValid["portablee164"]) {
      setPortableInput(portableForDisplay);
    }
  };
  return (
    <tr>
      <td className={styles.col3}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={props.onToggle}
        />
      </td>
      <td>
        <InputIcon
          value={name || ""}
          onChange={(value) => onMembreChange("name", value)}
          tooltip="Recopier vers le bas"
          onClick={() => onCopyDown("name")}
          showIcon={!!name}
          data-testid="nomInput"
          iconTestId="nomCopyDown"
          isValid={!!name && name.length > 1}
        >
          <FaLongArrowAltDown size="1.2em" />
        </InputIcon>
      </td>
      <td>
        <Input
          value={forename || ""}
          onChange={(value) => onMembreChange("forename", value)}
          data-testid="prenomInput"
          isValid={isValid["forename"]}
          isTouched={!!forename}
        />
      </td>
      <td className={styles.col10}>
        <Input
          value={birthdate || ""}
          onChange={(value) => onMembreChange("birthdate", value)}
          isValid={isValid["birthdate"]}
          data-testid="ddnInput"
          isTouched={!!birthdate}
        />
      </td>
      <td className={styles.col15}>
        <InputIcon
          value={portableInput || ""}
          onChange={handlePortableChange}
          tooltip="Recopier vers le bas"
          onClick={() => onCopyDown("portablee164")}
          isValid={isValid["portablee164"]}
          showIcon={isValid["portablee164"]}
          data-testid={"portableInput"}
          iconTestId={"portableCopyDown"}
          onBlur={handlePortableBlur}
        >
          <FaLongArrowAltDown size="1.2em" />
        </InputIcon>
      </td>
      <td className={styles.col15}>
        <InputIcon
          value={email || ""}
          onChange={(value) => onMembreChange("email", value)}
          tooltip="Recopier vers le bas"
          onClick={() => onCopyDown("email")}
          isValid={isValid["email"]}
          showIcon={isValid["email"]}
          data-testid={"emailInput"}
          iconTestId={"emailCopyDown"}
        >
          <FaLongArrowAltDown size="1.2em" />
        </InputIcon>
      </td>
      <td className={styles.col10}>
        <Select4<FamilyRank>
          items={[
            { key: "PARENT", label: "Parent" },
            { key: "GRANDPARENT", label: "Grand-parent" },
            { key: "CHILD", label: "Enfant" },
          ]}
          selected={familly_rank || null}
          onSelect={(value: FamilyRank | null) =>
            onMembreChange("familly_rank", value)
          }
          nullDisplay="-"
          className="w-full"
          testid="familyRankSelect"
        />
      </td>
      <td>
        <Button
          onClick={() => onRemoveMembre()}
          variant="destructive"
          size="sm"
          data-testid={"removeMembreButton"}
        >
          Retirer de la famille
        </Button>
      </td>
    </tr>
  );
};

export default FamilleGridRow;
